export enum PlayerPositionsShortEnum {
  "GOALKEEPER (GK)" = "GK",
  "LEFT BACK (LB)" = "LB",
  "CENTER BACK (CB)" = "CB",
  "SWEEPER (SW)" = "SW",
  "RIGHT BACK (RB)" = "RB",
  "LEFT MIDFIELDER (LMF)" = "LMF",
  "CENTER MIDFIELDER (CMF)" = "CMF",
  "RIGHT MIDFIELDER (RMF)" = "RMF",
  "ATTACKING MIDFIELDER (AMF)" = "AMF",
  "DEFENSIVE MIDFIELDER (DMF)" = "DMF",
  "LEFT WINGER (LW)" = "LW",
  "CENTER FORWARD (CF)" = "CF",
  "RIGHT WINGER (RW)" = "RW",
  "STRIKER (ST)" = "ST",
}

export enum PlayerPositions {
  goalkeeper = "GOALKEEPER (GK)",
  leftBack = "LEFT BACK (LB)",
  centerBack = "CENTER BACK (CB)",
  sweeper = "SWEEPER (SW)",
  rightBack = "RIGHT BACK (RB)",
  leftMidfielder = "LEFT MIDFIELDER (LMF)",
  centerMidfielder = "CENTER MIDFIELDER (CMF)",
  rightMidfielder = "RIGHT MIDFIELDER (RMF)",
  attackingMidFielder = "ATTACKING MIDFIELDER (AMF)",
  defensiveMidFielder = "DEFENSIVE MIDFIELDER (DMF)",
  leftWinger = "LEFT WINGER (LW)",
  centerForward = "CENTER FORWARD (CF)",
  rightWinger = "RIGHT WINGER (RW)",
  striker = "STRIKER (ST)",
}
export const playerPositionsList = Object.values(PlayerPositions);
